import React, { FormEvent, useContext, useEffect, useRef } from "react";
import HRStore from "../../app/stores/hrStore";
import LoadingComponent from "../../app/layout/LoadingComponent";
import {  Container, Grid, Header, List,} from "semantic-ui-react";
import { observer } from "mobx-react-lite";
import { Link } from "react-router-dom";
import { useState } from "react";
import { PieChart, Pie, Legend, Tooltip, ResponsiveContainer, Cell, LabelList, Label } from 'recharts';

let timer:any = null;
let count = 0;

const HRDashboard : React.FC = () => {
  const hrStore = useContext(HRStore);
  const { loadCertificateCharts, verifiedCount, unverifiedEmp, expireCertificate, changeList } = hrStore;

  const roll: any = useRef(null);
  
  const start = () => {
    if (unverifiedEmp.length > 7) {
    timer = setInterval(() => {
      count++;
      roll.current.style.top = ((-0.5)*count)+'px';
      if((-0.5*count) <= -50){
      changeList();
      count = count - 80;
      roll.current.style.top = (count*(-0.5)) + 'px'   
      }
   }, 50);}
   };

   const Stop = () => {
    clearInterval(timer);
    // timer.current = null;
  }

  useEffect(() => {
    loadCertificateCharts().then(()=> start());
    return () => {
      clearInterval(timer);
    };
  }, []);

  const verify = [
    { name: 'Verified Certificates', value: verifiedCount.verified },
    { name: 'Unverified Certificates', value: verifiedCount.unverified },
  ];

  const expiry = [
    { name: 'Expired', value: expireCertificate.expired },
    { name: 'In one month', value: expireCertificate.onemonth },
    { name: 'In three months', value: expireCertificate.threemonth },
    { name: 'Above three month', value: expireCertificate.unexpire },
  ];


   if (hrStore.loadingInitial)
     return <LoadingComponent content="Loading Human Resource" />;

  return (
    <div>
    <Container fluid style={{marginTop: '-5rem'}}>
      <Grid>
        <Grid.Column width='8'>
        <br/><br/>
        <Header color="violet" size="huge"> 
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Certificate Verification</Header>
        <PieChart width={480} height={250}>
          <Pie
            dataKey="value"
            isAnimationActive={false}
            data={verify}
            cx="50%"
            cy="50%"
            outerRadius={100}
          >
            <LabelList dataKey="name" position="outside" offset={20}/>
            <LabelList dataKey="value" />
            <Cell fill="#00C49F" />
            <Cell fill="#ff5d48"/>
          </Pie>
          {/* <Tooltip /> */}
          </PieChart>
      </Grid.Column>
      <Grid.Column width='8'>
        <br/><br/><br/><br/>
        <div onMouseEnter={Stop} onMouseLeave={start} role="list" className="ui list" 
        style={{height: "280px",  color: "teal", overflow: "hidden", fontSize: "16px", position: "relative"}}>
        <div className="content" ref={roll} style={{top: '0px', position: "absolute"}}>
        {unverifiedEmp.map(unverifiedEmployee => (
          <div key={unverifiedEmployee.name}>
    <List.Item><strong>{unverifiedEmployee.name}</strong> has <strong style={{ color: "red" }}>{unverifiedEmployee.unverifiedCert}</strong> unverified 
      certificates, 
    please click <Link to={`/hrmanagement/employees/${unverifiedEmployee.email}`} style={{ color: "blue" }}>here</Link> to view details.
    </List.Item>
    <br/>
    </div>
        ))}
        </div>
        </div>
      </Grid.Column>
      </Grid>
    </Container>

    <Container fluid >
      <Grid>
        <Grid.Column width='8'> 
        <br/><br/>
        <Header color="violet" size="huge">
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        &nbsp;&nbsp;&nbsp;
        Certificate Expiry</Header>       
        <PieChart width={480} height={250}>
          <Pie
            dataKey="value"
            isAnimationActive={false}
            data={expiry}
            cx="50%"
            cy="50%"
            outerRadius={100}
          >
            <LabelList dataKey="name" position="outside" offset={20}/>
            <LabelList dataKey="value" />
            <Cell fill="#E74C3C" />
            <Cell fill="#E67E22"/>
            <Cell fill="#F4D03F"/>
            <Cell fill="#2ECC71"/>
          </Pie>
          {/* <Tooltip /> */}
          </PieChart>
      </Grid.Column>
      <Grid.Column width='8'>
        <br/><br/><br/><br/><br/><br/>
        <List size='large'> 
    <List.Item > <span style={{color: 'red'}}>
      There are <strong>{expireCertificate.expired}</strong> expired certificates, please  
     click <Link to={`/hrmanagement/techniciancertificate/dashboard/expired`} style={{ color: "blue" }}>here</Link> to view details. </span>
    </List.Item>
    <br/><br/>
    <List.Item > <span style={{color: '#E67E22'}}>
      There are <strong>{expireCertificate.onemonth}</strong> certificates will expire in <strong>one month</strong>, 
    please click <Link to={`/hrmanagement/techniciancertificate/dashboard/onemonth`} style={{ color: "blue" }}>here</Link> to view details. </span>
    </List.Item>
    <br/><br/>
    <List.Item > <span style={{color: '#7D6608'}}>
      There are <strong>{expireCertificate.threemonth}</strong> certificates will expire in <strong>three month</strong>, 
    please click <Link to={`/hrmanagement/techniciancertificate/dashboard/threemonth`} style={{ color: "blue" }}>here</Link> to view details. </span>
    </List.Item>
  </List>
      </Grid.Column>
      </Grid>
    </Container>
    </div>
  );
};

export default observer(HRDashboard);
